<div class="confirm-dialog">
  <button class="close-btn" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>

  <div class="dialog-header">
    <div class="dialog-icon info">
      <i class="bi bi-info-circle-fill"></i>
    </div>

    <div class="dialog-title">
      <h2> Already Default {{ data.type === "configuration" ? "Configuration" : "Ruleset" }}</h2>
      <p> This {{ data.type }} is already set as the default for your organization.</p>
    </div>
  </div>

  <div class="dialog-body">
    <div class="info-box">
      <i class="bi bi-info-circle"></i>

      <span>
        If you want to change the default
        {{ data.type }}, please edit another {{ data.type }} and set it as the
        default instead.
      </span>
    </div>

    <p class="confirmation-text">No further action is required.</p>
  </div>

  <div class="dialog-actions">
    <button type="button" class="btn-cancel" (click)="cancel()">Close</button>
  </div>
</div>
